import {Button, message, Modal} from 'antd'
import {getId, getType} from 'apis/model/base'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import Async from 'modules/asyncCache/components/Async'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useEffect, useMemo, useState,} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {useLocation} from 'react-router-dom'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {showConfirmDialog, showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {bindQueryParam, bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {useCatholicHouseholds} from "../../../AppLocals/CatholicHousehold/functions/useCatholicHouseholds";
import {renderCatholicHousehold} from "../functions/renderCatholicHousehold";
import {
    catholicHousehold_getById_Api,
    catholicHousehold_getCatholicHouseholds_Api
} from "../../../../apis/catholicHousehold";
import {
    CreateCatholicHouseholdStepForm,
    DetailViewForm,
    EditCatholicHouseholdForm
} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdForm";
import {CatholicHouseholdActionTypes} from "../../../AppLocals/CatholicHousehold/consts/CatholicHouseholdActionTypes";
import {RiSearchEyeLine} from "react-icons/ri";
import {FullSideModalLayout} from "../../../../components/Modal/SideModalLayout";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import CatholicHouseholdMembers from "../../../AppLocals/CatholicHousehold/containers/CatholicHouseholdMembers";
import {CatholicHouseholdFilter} from "../filters/CatholicHouseholdFilter";
import CatholicHouseholdContext, {CatholicHouseholdProvider} from "../../../AppLocals/CatholicHousehold/CatholicHouseholdContext";
import {IoPeople} from "react-icons/io5";
import {PiCheckCircle} from "react-icons/pi";
import {CatholicHouseholdApproveForm} from "../components/CatholicHouseholdApproveForm";
import {LuUndo2} from "react-icons/lu";
import {ifThenElseMultipleConditions} from "../../../../helpers/ifThenElseMultipleConditions";
import {HiOutlineLink} from "react-icons/hi2";
import {ContextActionTypes} from "../../../AppLocals/factory/createContextMenu";
import getLinkToDetail, {getAbsoluteLinkToDetail} from "../../../../helpers/getLinkToDetail";
import copyToClipboard from "copy-to-clipboard";
import WorkspaceContext from "../../WorkspaceContext";
import {CatholicHouseholdImporter} from "./CatholicHouseholdImporter";
import LoadingBlock from "../../../Loading/LoadingBlock";


const CatholicHouseholds = ({
                                owner_id,
                                owner_type,
                                filter_actions = {
                                    sortBy: 'sort-by',
                                    keyword: 'keyword',
                                    status: 'status',
                                },
                            }) => {
    const t = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const {isSm, isLg} = useContext(LayoutContext)
    const [refreshKey, setRefreshKey] = useState()
    const [action, setAction] = useState({type: undefined, value: undefined,})
    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const statusParam = useRouteSearchParam(filter_actions.status) || "1"
    const [status, setStatus] = useState(statusParam)
    useEffect(() => {
        setStatus(statusParam)
    }, [statusParam])

    const onCancel = () => {
        setAction({})
    }
    const onRefresh = () => {
        setRefreshKey(Date.now())
    }
    const onSuccess = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const onError = notifyOnError(t)

    const {onCreate, onUpdate, onDelete, onChangeStatus} = useCatholicHouseholds({
        owner_type, owner_id,
        notifyListeners: {
            onCreated: onSuccess,
            onUpdated: () => {
                setRefreshKey(Date.now())
                setStatus(-1)
                onCancel()
            },
            onDeleted: onSuccess,
            onStatusChanged: onSuccess,
        },
    })

    const handleAction = (action, params) => {
        const [id, prop] = [getId(params), getType(params)]

        switch (action) {
            case ContextActionTypes.COPY:
                copyToClipboard(getAbsoluteLinkToDetail(params))
                message.success(t('copied'))
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_VIEW:
                history.push(getLinkToDetail(params))
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_IMPORT:
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_MEMBER:
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_CREATE:
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_UPDATE:
                setAction({type: action, value: params})
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_DELETE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'delete household',
                        message: 'are you sure you want to delete this household',
                        onOk: () => {
                            onDelete({}, {id})
                        },
                    })
                }
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_APPROVE:
                setAction({type: action, value: params})
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_UNDO_APPROVE:
                if (id) {
                    showConfirmDialog({
                        translate: t,
                        icon: <LuUndo2 className="anticon"/>,
                        title: 'undo approve',
                        message: 'undo the action of approving the catholic household',
                        onOk: () => {
                            onChangeStatus({status: -1}, {id})
                            setStatus(-1)
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-color-400"/>,
                        label: <span className="text-sm text-color-200">{t('view detail')}</span>,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_VIEW,
                    },
                    {
                        icon: <IoPeople size={14} className="text-green-500"/>,
                        label: <span className="text-sm text-color-200">{t('members')}</span>,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_MEMBER,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: <span className="text-sm text-color-200">{t('edit')}</span>,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_UPDATE,
                    },
                    {
                        icon: <PiCheckCircle size={14} className="text-green-600"/>,
                        label: <span className="text-sm text-color-200">{t('approve')}</span>,
                        disable: item?.status === 1,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_APPROVE,
                    },
                    {
                        icon: <LuUndo2 size={14} className="text-orange-500"/>,
                        label: ifThenElseMultipleConditions(
                            'undo',
                            item?.status === 1, <span className="text-sm text-color-200">{t('undo approve')}</span>,
                            item?.status === -2, <span className="text-sm text-color-200">{t('undo reject')}</span>
                        ),
                        disable: item?.status === -1,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_UNDO_APPROVE,
                    },
                    {
                        icon: <HiOutlineLink size={14} className="text-color-400"/>,
                        label: <span className="text-sm text-color-200">{t('copy link')}</span>,
                        key: ContextActionTypes.COPY,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: <span className="text-sm text-color-200">{t('delete')}</span>,
                        key: CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_DELETE,
                    },
                ].filter((e) => !!!e.disable),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const modal = useMemo(() => {
        const {id} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {title: undefined}
        let modal_params = {}
        switch (action?.type) {
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_IMPORT:
                title = (
                    <div className="uppercase text-center font-bold text-color-000 tracking-wide">
                        {t('import')}
                    </div>
                )
                params = {onCancel}
                modal_params = {
                    width: 600,
                    maskClosable: true,
                    closable: !isSm,
                    className: 'custom-modal'
                }
                Content = ({...rest}) => (
                    <WorkspaceContext.Consumer>
                        {({organization}) => {
                            return (
                                <CatholicHouseholdImporter
                                    {...rest}
                                    import_type={CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_IMPORT}
                                    type={getType(organization)}
                                    id={organization?.id}
                                    owner={organization}
                                />
                            )
                        }}
                    </WorkspaceContext.Consumer>
                )
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_VIEW:
                params = {onCancel}
                modal_params = {
                    width: 820,
                    maskClosable: true,
                    closable: !isSm,
                    className: 'custom-modal'
                }
                Content = ({...rest}) => (
                    <CatholicHouseholdProvider item={action.value}>
                        <CatholicHouseholdContext.Consumer>
                            {({item}) => {
                                return (
                                    <DetailViewForm
                                        {...rest}
                                        item={item}
                                    />
                                )
                            }}
                        </CatholicHouseholdContext.Consumer>
                    </CatholicHouseholdProvider>
                )
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_MEMBER:
                return (
                    <FullSideModalLayout
                        title={
                            <div
                                className="text-center font-bold text-sm md:text-lg text-color-000 uppercase leading-snug tracking-widest">
                                {t('family members')}
                            </div>
                        }
                        // maskClosable={true}
                        right={true}
                        onCancel={onCancel}>
                        {bindingSearch({
                            onCancel,
                            item: action?.value,
                        })(CatholicHouseholdMembers)}
                    </FullSideModalLayout>
                )
                break;
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_CREATE:
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCreate(values)
                    },
                    owner_type, owner_id,
                }
                modal_params = {
                    width: 720,
                    className: 'appModal custom-modal'
                }
                Content = CreateCatholicHouseholdStepForm
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_UPDATE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('edit catholic household')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                    handleOpenMemberManagement: () => {
                        handleAction(CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_MEMBER, action.value)
                    },
                    initialValues: action?.value
                }
                modal_params = {
                    width: 720,
                    maskClosable: false,
                    className: 'custom-modal'
                }
                Content = EditCatholicHouseholdForm
                Wrapper = ({children}) => (
                    <Async
                        {...{
                            query: bindQueryParam({id}),
                            apiInfo: catholicHousehold_getById_Api,
                        }}>
                        {({isLoading, response}) =>
                            _.isFunction(children)
                                ? children({
                                    isLoading,
                                    initialValues: getResponseItem(response),
                                })
                                : children
                        }
                    </Async>
                )
                break
            case CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_APPROVE:
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('approve catholic household')}
                    </div>
                )
                params = {
                    onCancel: () => {
                        setAction({})
                        setRefreshKey(Date.now())
                    },
                }
                modal_params = {
                    width: 740,
                    maskClosable: true,
                    className: 'appModal custom-modal'
                }
                Content = ({...rest}) => (
                    <CatholicHouseholdProvider item={action.value}>
                        <CatholicHouseholdContext.Consumer>
                            {({item}) => {
                                return (
                                    <CatholicHouseholdApproveForm
                                        {...rest}
                                        item={item}
                                        onCancel={() => {
                                            setAction({})
                                            setRefreshKey(Date.now())
                                        }}
                                    />
                                )
                            }}
                        </CatholicHouseholdContext.Consumer>
                    </CatholicHouseholdProvider>
                )
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                styles={{body: {padding: 0}}}
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{owner_id, owner_type}}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            status,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, status, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
            status
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            PaginationMeta: NullAsDefault,
            apiInfo: catholicHousehold_getCatholicHouseholds_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
            renderItem: renderCatholicHousehold({
                translate: t,
                isLg: isLg,
                renderContextMenu,
                handleAction: (type, value) => {
                    setAction({type, value});
                }
            }),
            renderWrap: (child) => (
                <div className="mt-2 flex flex-col divide-y divide-gray-200 list-item-workspace">
                    {child}
                </div>
            )
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        AdvancedFilter: CatholicHouseholdFilter,
        dependencies: [owner_id, owner_type, status],
        withKey: createPagerKey(refresh_deps),
    })

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t('catholic household')}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                </div>
                <div className="flex gap-x-3">
                    <Button
                        color="primary" variant="filled"
                        className="rounded-lg no-border font-semibold flex-1"
                        onClick={() => {
                            handleAction(CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_IMPORT)
                        }}>
                        {t('import')}
                    </Button>
                    <Button
                        color="primary" variant="solid"
                        className="rounded-lg no-border font-semibold flex-1"
                        onClick={() => {
                            handleAction(CatholicHouseholdActionTypes.CATHOLIC_HOUSEHOLD_CREATE)
                        }}>
                        {t('create')}
                    </Button>
                </div>
            </div>
            {pager_widget}
            {modal}
            <div className="h-16"/>
        </div>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(CatholicHouseholds)
